import { render, staticRenderFns } from "./userArchives.vue?vue&type=template&id=d191cd40&scoped=true&"
import script from "./userArchives.vue?vue&type=script&lang=js&"
export * from "./userArchives.vue?vue&type=script&lang=js&"
import style0 from "./userArchives.vue?vue&type=style&index=0&id=d191cd40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d191cd40",
  null
  
)

export default component.exports